import React, {FC} from 'react';

/** Русский текст страницы «Партнёрская (агентская) программа» (i18n: оболочка выбирает контентный компонент
 * по языку; h1 находится в hero оболочки, текст начинается с h2, структура элементов 1:1 соответствует en.tsx,
 * типографику обеспечивает Prose (.v3-prose)). 2026-09-17 AI-перевод. */
const RuContent: FC = () => {
  return (
    <>
      <section>
        <h2>Что такое партнёрская (агентская) программа</h2>
        <p>
          Чтобы охватить больше продавцов, которым нужна локализация контента для трансграничной торговли, и
          отблагодарить постоянных пользователей, рекомендующих Xiangji коллегам по бизнесу, Xiangji запустила
          партнёрскую (агентскую) программу. Достаточно поделиться своей личной реферальной ссылкой с друзьями, которые
          занимаются трансграничной торговлей и нуждаются в генерации товарных изображений, локализации видео или
          создании главных и детальных изображений для карточек товаров, — как только они зарегистрируются как
          пользователи Xiangji, вы будете получать реферальное вознаграждение с каждого их последующего платежа:
          бессрочно, без ограничения срока и без необходимости приглашать заново.
        </p>
        <div className="v3-note">
          <p>
            Программа доступна каждому пользователю Xiangji — не требуется ни дополнительная квалификация, ни одобрение:
            после регистрации у вас уже есть собственная реферальная ссылка, которой можно делиться в любой момент.
          </p>
        </div>
      </section>
      <section>
        <h2>Правила вознаграждений</h2>
        <p>
          После того как друг зарегистрируется по вашей реферальной ссылке и совершит платёж, по каждой сделке вы можете
          выбрать один из двух вариантов вознаграждения — они взаимоисключающие, и выплата производится отдельно по
          каждому платежу:
        </p>
        <ul>
          <li>
            <strong>Вознаграждение квотой 15%</strong>: сумма платежа друга конвертируется в эквивалентное количество
            сервисных кредитов Xiangji, которые можно использовать непосредственно в своём аккаунте для генерации
            изображений, локализации видео или создания контента для карточек товаров, — идеальный вариант, если вы сами
            активно пользуетесь Xiangji;
          </li>
          <li>
            <strong>Вознаграждение деньгами 10% (ребейт)</strong>: выплачивается напрямую деньгами — идеальный вариант,
            если вам важен немедленный доход.
          </li>
        </ul>
        <p>
          Например: у Лао Вана, пользователя Xiangji, есть хорошая знакомая Сяоли, которая открывает бизнес в сфере
          трансграничной электронной коммерции и нуждается в генерации товарных изображений и создании контента для
          карточек товаров. Уверенный, что Xiangji даёт отличные результаты по низкой цене, Лао Ван поделился с Сяоли
          своей реферальной ссылкой. После того как Сяоли зарегистрировалась и приобрела 10 000 кредитов на генерацию
          изображений, Лао Ван может выбрать <strong>вознаграждение квотой 15%</strong> (1 500 кредитов на генерацию
          изображений) или <strong>вознаграждение деньгами 10% (ребейт)</strong>.
        </p>
      </section>
      <section>
        <h2>Как стать агентом</h2>
        <h3>1. Получите свою личную реферальную ссылку</h3>
        <p>
          Войдя в рабочее пространство Xiangji, найдите свою личную реферальную ссылку в центре аккаунта — она навсегда
          привязана к вашему аккаунту.
        </p>
        <img
          alt="Страница с реферальной ссылкой"
          decoding="async"
          loading="lazy"
          src="https://www.xiangjifanyi.com/doc/assets/images/proxyLink-b19297b66a83019a38381eedec4e6a15.jpg"
        />
        <h3>2. Отправьте ссылку друзьям-продавцам, выходящим на зарубежные рынки</h3>
        <p>
          Им потребуется зарегистрироваться по номеру телефона — вводить ваш реферальный код вручную не нужно, система
          привязывает реферала автоматически.
        </p>
        <h3>3. Отслеживайте рефералов и вознаграждения в любое время в разделе «Список пользователей»</h3>
        <p>
          После регистрации друга вы увидите каждого привлечённого клиента в «Списке пользователей» рабочего
          пространства и сможете отслеживать их платежи и статус вознаграждений.
        </p>
        <img
          alt="Страница со списком привлечённых клиентов"
          decoding="async"
          loading="lazy"
          src="https://www.xiangjifanyi.com/doc/assets/images/customerList-6a1f51325e636766f7270d307f93568b.jpg"
        />
      </section>
    </>
  );
};

export default RuContent;
